import type { FC } from "react";
import { useCallback } from "react";

import classNames from "classnames";

import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { BirthDateFormCtas as BirthDateFormCtasUI } from "@jti/ui/eva-components/SoftAgeVerification";

import type { birthDateFormCtasInputs } from "./BirthDateFormCtas.builder";

import styles from "./BirthDateFormCtas.module.scss";

type BirthDateFormCtasProps = BuilderComponentProps<typeof birthDateFormCtasInputs>;

export const BirthDateFormCtas: FC<BirthDateFormCtasProps> = ({ confirmLabel, leaveLabel, leaveUrl, attributes }) => {
  const onLeaveClick = useCallback(() => {
    dispatchTrackingEvent(TrackingEvents.TrackingAgeVerificationClick, {
      age_confirmation: "no",
    });
  }, []);

  return (
    <div {...attributes} className={classNames(styles.wrapper, attributes?.className)}>
      <BirthDateFormCtasUI
        confirmLabel={confirmLabel}
        leaveLabel={leaveLabel}
        leaveUrl={leaveUrl}
        onLeaveClick={onLeaveClick}
      />
    </div>
  );
};
